export enum USER_PERMISSIONS {
  SUPERADMIN = 'SUPERADMIN',
  SUPPLIER_ACCESS = 'SUPPLIER_ACCESS',
  FINANCIAL_ACCESS = 'FINANCIAL_ACCESS',
  AUDIT_ACCESS = 'AUDIT_ACCESS'
}

export interface IPermission {
  name: string;
  description: string;
}

export enum Actions {
  Create = 'create',
  Edit = 'edit'
}

export interface PermissionRemoveErrorResponse {
  statusCode: number;
  message: string;
  error: string;
}
